export class EnviarEscribiendoRequest {

    public indicador: boolean;
    public participantID: string;

}

